import { render, staticRenderFns } from "./ColumChart.vue?vue&type=template&id=55f85688&scoped=true&"
import script from "./ColumChart.vue?vue&type=script&lang=js&"
export * from "./ColumChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f85688",
  null
  
)

export default component.exports